import _slicedToArray from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import campaignData from '../../json/campaigns.json';
import { cookie } from '../util/storage';
import { getParams } from '../util/url';
import formatPhoneNumber from '../util/formatters';

var updatePhoneNumber = function updatePhoneNumber(key) {
  var phoneNumber = campaignData[key] || '18002446224';
  var campaignPhoneNumbers = document.querySelectorAll('.campaign-phone-number:not(.adobe-target-modified)');
  console.log("Setting the campaign_phone cookie to equal ".concat(phoneNumber, ". \nCampaign ID provided: ").concat(key, "."));
  cookie.set('campaign_phone', phoneNumber);
  [].forEach.call(campaignPhoneNumbers, function (ele) {
    ele.innerHTML = "<a class='campaign-phone-link' href='tel:".concat(formatPhoneNumber(phoneNumber), "'>\n      ").concat(formatPhoneNumber(phoneNumber, '-'), "\n    </a>");
  });
};

function organic() {
  var domainName = document.referrer;
  var folderName = location.pathname;

  if (folderName.match(/(supplemental)/gm)) {
    // For Supplemental Pages Only
    var pages = {
      'accident-expense-insurance': '18553588529',
      'cancer-insurance': '18553588530',
      'heart-stroke-insurance': '18553588531',
      'whole-life-insurance': '18553588533',
      'cancer-treatment-insurance': '18553588532',
      'hospital-indemnity-insurance': '18553588530',
      default: '18553588528'
    };
    var files = Object.keys(pages);
    var lookupPhone = files.find(function (e) {
      return folderName.includes(e);
    }) || 'default';
    var customPhone = pages[lookupPhone];
    var acxiomdatach01 = 'ANCORG';
    var campaignPhoneNumbers = document.querySelectorAll('.campaign-phone-number:not(.adobe-target-modified)');
    cookie.set('acxiomdatach01', acxiomdatach01);
    cookie.set('acxiomdatacht', 'Cigna Supplemental');
    cookie.set('campaign_phone', customPhone);
    var custMatch = customPhone.match(/^(?:\d{0,1})(\d{3})(\d{3})(\d{4})$/);
    var custFormat = ['1', "(".concat(custMatch[1], ")"), "".concat(custMatch[2], "-").concat(custMatch[3])].join(' ');
    [].forEach.call(campaignPhoneNumbers, function (ele) {
      ele.innerHTML = "<a class='campaign-phone-link' href='tel:".concat(formatPhoneNumber(custFormat), "'>\n        ").concat(formatPhoneNumber(custFormat, '-'), "\n      </a>");
    });
  } else {
    // For Dental Pages Only
    var dentalDATA = {
      google: ['OSGDEN', 'Google_Search'],
      bing: ['OSBDEN', 'Bing_Search'],
      yahoo: ['OSYDEN', 'Yahoo_Search'],
      cigna: ['OCPDEN', 'Other_Cigna_page'],
      default: ['DRTDEN', 'Typed_URL']
    }; // For Any Other Campaigns

    var genericDATA = {
      google: ['OSGIFP', 'Google_Search', 'Google_Search'],
      bing: ['OSBIFP', 'Bing_Search', 'Bing_Search'],
      yahoo: ['OSYIFP', 'Yahoo_Search', 'Yahoo_Search'],
      cigna: ['OCPIFP', 'Other_Cigna_page', 'Other_Cigna_page'],
      default: ['DRTIFP', 'Typed_URL', 'Typed_URL']
    };

    if (folderName.match(/(dental-insurance-plans)/gm)) {
      var lookupKeys = Object.keys(dentalDATA);
      var lookupReferrer = lookupKeys.find(function (element) {
        return domainName.includes(element) === true;
      });

      var _ref = dentalDATA[lookupReferrer] || dentalDATA.default,
          _ref2 = _slicedToArray(_ref, 2),
          _acxiomdatach = _ref2[0],
          acxiomdatacht = _ref2[1];

      cookie.set('acxiomdatach01', _acxiomdatach);
      cookie.set('acxiomdatacht', acxiomdatacht);
      updatePhoneNumber(_acxiomdatach);
    } else {
      var _lookupKeys = Object.keys(genericDATA);

      var _lookupReferrer = _lookupKeys.find(function (element) {
        return domainName.includes(element) === true;
      });

      var _ref3 = genericDATA[_lookupReferrer] || genericDATA.default,
          _ref4 = _slicedToArray(_ref3, 3),
          _acxiomdatach2 = _ref4[0],
          _acxiomdatacht = _ref4[1],
          acxiomdatacht02 = _ref4[2];

      cookie.set('acxiomdatach01', _acxiomdatach2);
      cookie.set('acxiomdatacht', _acxiomdatacht);
      cookie.set('acxiomdatacht02', acxiomdatacht02);
      updatePhoneNumber(_acxiomdatach2);
    }
  }
}

function updateCampaign(key, val) {
  if (key === 'acxiomdatach01' || key === 'utm_campaign') {
    console.log("Setting campaign cookie for ".concat(key, " to equal ").concat(val, "."));
    cookie.set('acxiomdatach01', val);
    updatePhoneNumber(val);
  } else if (key === 'acxiomdatacht' || key === 'utm_medium') {
    console.log("Setting campaign cookie for ".concat(key, " to equal ").concat(val, "."));
    cookie.set('acxiomdatacht', val);
  } else if (key === 'acxiomdatacht02' || key === 'utm_source') {
    console.log("Setting campaign cookie for ".concat(key, " to equal ").concat(val, "."));
    cookie.set('acxiomdatacht02', val);
  } else {
    organic();
  }
}

function processCampaignURL() {
  var params = getParams(location.search);

  if (location.search === '' || !params.utm_campaign) {
    console.log('Url search string not present calling organic()...');
    organic();
  } else {
    console.log('Looking at the url search string (query parameters)...');

    var _location$search$spli = location.search.split('?'),
        _location$search$spli2 = _slicedToArray(_location$search$spli, 2),
        searchString = _location$search$spli2[1];

    searchString.split('&').forEach(function (element) {
      var _element$split = element.split('='),
          _element$split2 = _slicedToArray(_element$split, 2),
          key = _element$split2[0],
          val = _element$split2[1];

      if (['utm_campaign', 'utm_medium', 'utm_source'].includes(key)) updateCampaign(key, val);
    });
  }
}

function dynamicQuoteApplyURL() {
  var cid = 's037';
  var campaignID = cookie.get('acxiomdatach01');
  var campaignMedium = cookie.get('acxiomdatacht');
  var campaignSource = cookie.get('acxiomdatacht02');
  var campaignPhone = cookie.get('campaign_phone');
  var quoteSupplemental = document.querySelectorAll('a[href*="//cignasupplemental.expressenroll.com"]');
  var quoteDental = document.querySelectorAll('a:not(.adobe-target-modified)[href*="//cignaindividual.com/public/Users/ExternalConnect.aspx"], a:not(.adobe-target-modified)[href*="//cignaindividual.com/public/Quoting/Individual/EnterQuoteCriteria.aspx"]');
  var quoteMedical = document.querySelectorAll('a[href*="//cignaindividual.com/public-ede"]');
  [].forEach.call(quoteSupplemental, function (ele) {
    ele.setAttribute('href', "https://cignasupplemental.expressenroll.com/?cid=".concat(cid, "&campaign_id=").concat(campaignID));
  });
  [].forEach.call(quoteDental, function (ele) {
    ele.setAttribute('href', "https://cignaindividual.com/public/Users/ExternalConnect.aspx?link_case=quote&campaign_id=".concat(campaignID, "&acxiomci01=").concat(campaignID, "&acxiomcht=").concat(campaignMedium, "&call=").concat(formatPhoneNumber(campaignPhone, '.')));
  });
  [].forEach.call(quoteMedical, function (ele) {
    ele.setAttribute('href', "https://cignaindividual.com/public-ede/?utm_source=".concat(campaignSource, "&utm_medium=").concat(campaignMedium, "&utm_campaign=").concat(campaignID));
  });
}

export default (function () {
  console.log('Looking for the main campaign cookie...');

  if (cookie.get('acxiomdatach01') && cookie.get('acxiomdatach02') && !location.pathname.match(/(supplemental)/gm)) {
    console.log('Main cookie set.. Trying to retrieve the other cookies required...');
    ['acxiomdatach01', 'acxiomdatacht', 'acxiomdatach02'].forEach(function (element) {
      return updateCampaign(element, cookie.get(element));
    });
  } else {
    console.log('Campaign cookies not set calling processCampaignURL()...');
    processCampaignURL();
  }

  dynamicQuoteApplyURL();
});